import React, { useContext } from "react";
import { RegistrationFormContext } from "./types";
import { InputRadio } from "../../../../HtmlComponents/InputRadio";

const Section8 = () => {
  const {
    practiceHealthcareDiagnosis, setPracticeHealthcareDiagnosis,
    siNon, setSiNon
  } = useContext(RegistrationFormContext);

  return (
    <>
      <div>
        <p className='font-bold text-main'>{"32) "}exercez-vous la medecine de soins et ou de diagnostic: </p>
        <InputRadio 
          checked={practiceHealthcareDiagnosis === "La medecine dentaire" && true} 
          labelName="La medecine dentaire"
          id="La medecine dentaire" 
          value={"La medecine dentaire"} 
          setValue={setPracticeHealthcareDiagnosis}
        />
        <InputRadio 
          checked={practiceHealthcareDiagnosis === "La medecine dentaire conjointement avec ou plusieurs compétences reconnues par l'ordre" && true} 
          labelName="La medecine dentaire conjointement avec ou plusieurs compétences reconnues par l'ordre"
          id="La medecine dentaire conjointement avec ou plusieurs compétences reconnues par l'ordre" 
          value={"La medecine dentaire conjointement avec ou plusieurs compétences reconnues par l'ordre"} 
          setValue={setPracticeHealthcareDiagnosis}
        />
        <InputRadio 
          checked={practiceHealthcareDiagnosis === "En qualité de spécialiste ou de compétent exclusif" && true} 
          labelName="En qualité de spécialiste ou de compétent exclusif"
          id="En qualité de spécialiste ou de compétent exclusif" 
          value={"En qualité de spécialiste ou de compétent exclusif"} 
          setValue={setPracticeHealthcareDiagnosis}
        />
        <InputRadio 
          checked={practiceHealthcareDiagnosis === "La premiére discipline indiquée Rubrique 18" && true} 
          labelName="La premiére discipline indiquée Rubrique 18"
          id="La premiére discipline indiquée Rubrique 18" 
          value={"La premiére discipline indiquée Rubrique 18"} 
          setValue={setPracticeHealthcareDiagnosis}
        />
        <InputRadio 
          checked={practiceHealthcareDiagnosis === "Les deux disciplines indiquées rubriques 18" && true} 
          labelName="Les deux disciplines indiquées rubriques 18"
          id="Les deux disciplines indiquées rubriques 18" 
          value={"Les deux disciplines indiquées rubriques 18"} 
          setValue={setPracticeHealthcareDiagnosis}
        />
        <InputRadio 
          checked={practiceHealthcareDiagnosis === "Les trois disciplines indiquées rubriques 18" && true} 
          labelName="Les trois disciplines indiquées rubriques 18"
          id="Les trois disciplines indiquées rubriques 18" 
          value={"Les trois disciplines indiquées rubriques 18"} 
          setValue={setPracticeHealthcareDiagnosis}
        />
        <InputRadio 
          checked={practiceHealthcareDiagnosis === "Exclusivement Une discipline pour laquelle il existe une qualification sans etre accordé par l'ordre" && true} 
          labelName="Exclusivement Une discipline pour laquelle il existe une qualification sans etre accordé par l'ordre"
          id="Exclusivement Une discipline pour laquelle il existe une qualification sans etre accordé par l'ordre" 
          value={"Exclusivement Une discipline pour laquelle il existe une qualification sans etre accordé par l'ordre"} 
          setValue={setPracticeHealthcareDiagnosis}
        />
        <InputRadio 
          checked={practiceHealthcareDiagnosis === "Exclusivement Une discipline pour laquelle il n'existe pas de qualification accordee par l'ordre et pas de diplome de specialiste actuellement" && true} 
          labelName="Exclusivement Une discipline pour laquelle il n'existe pas de qualification accordee par l'ordre et pas de diplome de specialiste actuellement"
          id="Exclusivement Une discipline pour laquelle il n'existe pas de qualification accordee par l'ordre et pas de diplome de specialiste actuellement" 
          value={"Exclusivement Une discipline pour laquelle il n'existe pas de qualification accordee par l'ordre et pas de diplome de specialiste actuellement"} 
          setValue={setPracticeHealthcareDiagnosis}
        />
      </div>
      <div>
        <p className='font-bold text-main'>{"33) "}Sinon: </p>
        <InputRadio 
          checked={siNon === "Avez-vous cessé d'exercer Retraite" && true} 
          labelName="Avez-vous cessé d'exercer Retraite"
          id="Avez-vous cessé d'exercer Retraite" 
          value={"Avez-vous cessé d'exercer Retraite"} 
          setValue={setSiNon}
        />
        <InputRadio 
          checked={siNon === "Sans avoir aucune activité medicale rénumérée" && true} 
          labelName="Sans avoir aucune activité medicale rénumérée"
          id="Sans avoir aucune activité medicale rénumérée" 
          value={"Sans avoir aucune activité medicale rénumérée"} 
          setValue={setSiNon}
        />
        <InputRadio 
          checked={siNon === "En ayant encore une activité rénumérée" && true} 
          labelName="En ayant encore une activité rénumérée(sociale, administrative, entre expertise, etc..)"
          id="En ayant encore une activité rénumérée" 
          value={"En ayant encore une activité rénumérée"} 
          setValue={setSiNon}
        />
      </div>
    </>
  );
};

export default Section8;
